import gql from 'graphql-tag';

export default gql`
  mutation updateEvent(
    $id: Int!
    $category_id: Int
    $promote_homepage: Boolean
    $event_date: Date
    $details: [EventDetailInput]
    $blocks: JSON
  ) {
    updateEvent(
      id: $id
      input: {
        category_id: $category_id
        promote_homepage: $promote_homepage
        event_date: $event_date
        details: $details
        blocks: $blocks
      }
    ) {
      id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/graphql/event/update.js